import { Module } from 'vuex';

import { ShiftCMSState } from '@/store';
import { Feedback } from '@/models/feedback.model';
import feedbackService from '@/services/feedback.service';

export interface FeedbackState {
  feedback: Feedback[];
}

export enum FeedbackMutations {
  SetFeedback = 'fs/SetFeedback',
}

export enum FeedbackActions {
  GetFeedback = 'fs/GetFeedback',
  AddFeedback = 'fs/AddFeedback',
  UpdateFeedback = 'fs/UpdateFeedback',
  UpdateFeedbackOrder = 'fs/UpdateFeedbackOrder',
  DeleteFeedback = 'fs/DeleteFeedback',
  ResolveFeedback = 'fs/ResolveFeedback',
}

const sn = (str: FeedbackActions | FeedbackMutations): string =>
  str.replace(/fs\//g, '');

export const feedbackStore: Module<FeedbackState, ShiftCMSState> = {
  namespaced: true,
  state: {
    feedback: [],
  },
  mutations: {
    [sn(FeedbackMutations.SetFeedback)](state, feedback: Feedback[]) {
      state.feedback = feedback;
    },
  },
  actions: {
    async [sn(FeedbackActions.GetFeedback)]({ commit }) {
      const res = await feedbackService.getList();
      if (res.status) {
        commit(sn(FeedbackMutations.SetFeedback), res.data);
      }
    },
    async [sn(FeedbackActions.UpdateFeedback)](
      { dispatch },
      feedback: Feedback,
    ) {
      const res = await feedbackService.update(feedback.id, feedback);
      if (res.status) {
        dispatch(sn(FeedbackActions.GetFeedback));
      }
    },
    async [sn(FeedbackActions.DeleteFeedback)]({ dispatch }, id: number) {
      const res = await feedbackService.delete(id);

      if (res.status) {
        dispatch(sn(FeedbackActions.GetFeedback));
      }
    },
    async [sn(FeedbackActions.ResolveFeedback)]({ state }, id: number) {
      const res = await feedbackService.update(id, { resolved: true });

      state.feedback = [...state.feedback.filter((f) => f.id !== id), res.data];
    },
  },
};
